"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var updateFavoritesUserOption_1 = require("./../updateFavoritesUserOption");
var setupFavoritePersona_1 = require("./setupFavoritePersona");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var owa_mail_persona_search_folder_services_1 = require("owa-mail-persona-search-folder-services");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('synchronizeSearchFolder')(function synchronizeSearchFolder(persona) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, parentFolderId, _a, searchFolderPersona, searchFolder;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = owa_mail_favorites_store_1.getStore();
                    _a = state.favoritePersonasRoodFolderId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.getFavoritePersonasRootFolderId()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    parentFolderId = _a;
                    searchFolderPersona = {
                        personaId: persona.id,
                        displayName: persona.displayName,
                        allEmailAddresses: persona.allEmailAddresses,
                    };
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.synchronizePersonaSearchFolder(searchFolderPersona, parentFolderId)];
                case 3:
                    searchFolder = _b.sent();
                    setupFavoritePersona_1.default(searchFolder);
                    persona.isSyncUpdateDone = true;
                    if (!state.haveFavoritePersonasChanged) return [3 /*break*/, 5];
                    state.haveFavoritePersonasChanged = false;
                    return [4 /*yield*/, updateFavoritesUserOption_1.default()];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=synchronizeSearchFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/synchronizeSearchFolder.js
// module id = 3166
// module chunks = 14 68